import { render, staticRenderFns } from "./chat_open.vue?vue&type=template&id=0288df1c&scoped=true&"
import script from "./chat_open.vue?vue&type=script&lang=ts&"
export * from "./chat_open.vue?vue&type=script&lang=ts&"
import style0 from "./chat_open.vue?vue&type=style&index=0&id=0288df1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0288df1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VDivider,VIcon,VTextarea})
